import { FC } from "react";
import { Box, NumberInput, Stack, Text } from "@mantine/core";
import { FilterComponentProps } from ".";

const UntilFollowUpFilter: FC<FilterComponentProps> = ({
  onFilterControlChange,
  filterControl
}) => {

  return (
    <Box mt="xl">
      <Stack align="center">
        <Text>
          between
        </Text>
        <NumberInput
          w="80px"
          hideControls
          value={filterControl?.minDaysUntilFollowUp || 0}
          onChange={(e) => onFilterControlChange({
            ...filterControl,
            minDaysUntilFollowUp: e as number,
          })}
          thousandSeparator=","
          decimalSeparator="."
          inputMode="decimal"
          ml={-30}
          styles={{
            input: {
              fontSize: 24,        // ← stops iOS zoom
              paddingTop: 0,
              paddingBottom: 0,
              borderTop: "none",
              borderLeft: "none",
              borderRight: "none",
              textAlign: "center",
            },
          }} />
        <Text>
          Days
        </Text>
        <Text>
          to
        </Text>
        <NumberInput
          w="80px"
          hideControls
          value={filterControl?.maxDaysUntilFollowUp || 0}
          onChange={(e) => onFilterControlChange({
            ...filterControl,
            maxDaysUntilFollowUp: e as number,
          })}
          thousandSeparator=","
          decimalSeparator="."
          inputMode="decimal"
          ml={-30}
          styles={{
            input: {
              fontSize: 24,        // ← stops iOS zoom
              paddingTop: 0,
              paddingBottom: 0,
              borderTop: "none",
              borderLeft: "none",
              borderRight: "none",
              textAlign: "center",
            },
          }} />
        <Text>
          Days
        </Text>
      </Stack>
    </Box>
  );
};

export default UntilFollowUpFilter;